window.LoopService = window.LoopService || {};

window.LoopService.Subscription = {
  /**
   * Reactivate a cancelled subscription
   */
  reactivate: async ({ subscriptionId, country }) => {
    try {
      if (!subscriptionId) {
        throw new Error("reactivateSubscription: missing subscriptionId");
      }

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const url = `${baseUrl}/loop/subscription/reactivate`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            subscriptionId: subscriptionId,
            country: country,
          }),
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Subscription reactivation failed:", error);
      throw error;
    }
  },

  getSubscription: async ({ subscriptionId, country }) => {
    try {
      if (!subscriptionId) {
        throw new Error("getSubscription: missing subscriptionId");
      }

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const query = country ? `?country=${encodeURIComponent(country)}` : "";
      const url = `${baseUrl}/loop/subscriptions/${subscriptionId}${query}`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        { method: "GET" }
      );

      return await response.json();
    } catch (error) {
      console.error("Subscription details fetch failed:", error);
      throw error;
    }
  },

  /**
   * Place an order for a subscription
   */
  placeOrder: async ({ subscriptionId, country }) => {
    try {
      if (!subscriptionId) {
        throw new Error("placeOrder: missing subscriptionId");
      }

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const url = `${baseUrl}/loop/subscription/place-order`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            subscriptionId: subscriptionId,
            country: country,
          }),
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Place order failed:", error);
      throw error;
    }
  },

  /**
   * Reactivate subscription and place order in one call
   */
  reactivateAndPlaceOrder: async ({ subscriptionId, country }) => {
    try {
      if (!subscriptionId) {
        throw new Error("reactivateAndPlaceOrder: missing subscriptionId");
      }

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const url = `${baseUrl}/loop/subscription/reactivate-and-place-order`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            subscriptionId: subscriptionId,
            country: country,
          }),
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Reactivate and place order failed:", error);
      throw error;
    }
  },

  /**
   * Remove line item from subscription
   */
  removeLineItem: async ({ subscriptionId, lineItemId, country }) => {
    try {
      if (!subscriptionId || !lineItemId) {
        throw new Error("removeLineItem: missing subscriptionId or lineItemId");
      }

      const baseUrl = window.LoopService.Base.getDigitalOceanBaseUrl();
      const url = `${baseUrl}/subscription/${subscriptionId}/country/${country}/line/${lineItemId}`;

      const response = await window.LoopService.Base.makeAuthenticatedRequest(
        url,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Remove line item failed:", error);
      throw error;
    }
  },
};
